// Auto-generated file — DO NOT EDIT
import accent1 from "../assets/logos/accent/box.png";
import accent2 from "../assets/logos/accent/brackets.png";
import accent3 from "../assets/logos/accent/bracketsCurly.png";
import accent4 from "../assets/logos/accent/bracketsRound.png";
import accent5 from "../assets/logos/accent/bracketsSquare.png";
import accent6 from "../assets/logos/accent/burst.png";
import accent7 from "../assets/logos/accent/caret.png";
import accent8 from "../assets/logos/accent/checkers.png";
import accent9 from "../assets/logos/accent/circle.png";
import accent10 from "../assets/logos/accent/circleDashed.png";
import accent11 from "../assets/logos/accent/circleNotch.png";
import accent12 from "../assets/logos/accent/circles.png";
import accent13 from "../assets/logos/accent/circlesFour.png";
import accent14 from "../assets/logos/accent/circlesThree.png";
import accent15 from "../assets/logos/accent/code.png";
import accent16 from "../assets/logos/accent/corners.png";
import accent17 from "../assets/logos/accent/crop.png";
import accent18 from "../assets/logos/accent/crosshair.png";
import accent19 from "../assets/logos/accent/dot.png";
import accent20 from "../assets/logos/accent/dotaThreeVertical.png";
import accent21 from "../assets/logos/accent/dotsThree.png";
import accent22 from "../assets/logos/accent/empty.png";
import accent23 from "../assets/logos/accent/gradient.png";
import accent24 from "../assets/logos/accent/greater.png";
import accent25 from "../assets/logos/accent/intersect.png";
import accent26 from "../assets/logos/accent/intersection.png";
import accent27 from "../assets/logos/accent/lineHoriztonal.png";
import accent28 from "../assets/logos/accent/lineVertical.png";
import accent29 from "../assets/logos/accent/notches.png";
import accent30 from "../assets/logos/accent/paper.png";
import accent31 from "../assets/logos/accent/pin.png";
import accent32 from "../assets/logos/accent/pipe.png";
import accent33 from "../assets/logos/accent/placeholder.png";
import accent34 from "../assets/logos/accent/position.png";
import accent35 from "../assets/logos/accent/prohibit.png";
import accent36 from "../assets/logos/accent/sawtooth.png";
import accent37 from "../assets/logos/accent/signal.png";
import accent38 from "../assets/logos/accent/sine.png";
import accent39 from "../assets/logos/accent/slideshow.png";
import accent40 from "../assets/logos/accent/sphere.png";
import accent41 from "../assets/logos/accent/subset.png";
import accent42 from "../assets/logos/accent/superset.png";
import accent43 from "../assets/logos/accent/tag.png";
import accent44 from "../assets/logos/accent/tilde.png";
import accent45 from "../assets/logos/accent/triangle.png";
import accent46 from "../assets/logos/accent/union.png";
import accent47 from "../assets/logos/accent/vignette.png";
import accent48 from "../assets/logos/accent/waveform.png";
import accent49 from "../assets/logos/accent/waves.png";
import accent50 from "../assets/logos/accent/zero.png";
import shape1 from "../assets/logos/shape/banner.png";
import shape2 from "../assets/logos/shape/circle.png";
import shape3 from "../assets/logos/shape/diamond.png";
import shape4 from "../assets/logos/shape/hexagon.png";
import shape5 from "../assets/logos/shape/octagon.png";
import shape6 from "../assets/logos/shape/parallelogram.png";
import shape7 from "../assets/logos/shape/pentagon.png";
import shape8 from "../assets/logos/shape/rectangle.png";
import shape9 from "../assets/logos/shape/seal.png";
import shape10 from "../assets/logos/shape/shield.png";
import shape11 from "../assets/logos/shape/square.png";
import shape12 from "../assets/logos/shape/star.png";
import shape13 from "../assets/logos/shape/triangle.png";
import symbol1 from "../assets/logos/symbol/airplane.png";
import symbol2 from "../assets/logos/symbol/atom.png";
import symbol3 from "../assets/logos/symbol/bank.png";
import symbol4 from "../assets/logos/symbol/briefcase.png";
import symbol5 from "../assets/logos/symbol/chartBar.png";
import symbol6 from "../assets/logos/symbol/chartPie.png";
import symbol7 from "../assets/logos/symbol/chip.png";
import symbol8 from "../assets/logos/symbol/circle.png";
import symbol9 from "../assets/logos/symbol/circuit.png";
import symbol10 from "../assets/logos/symbol/cloud.png";
import symbol11 from "../assets/logos/symbol/code.png";
import symbol12 from "../assets/logos/symbol/coin.png";
import symbol13 from "../assets/logos/symbol/compass.png";
import symbol14 from "../assets/logos/symbol/cube.png";
import symbol15 from "../assets/logos/symbol/database.png";
import symbol16 from "../assets/logos/symbol/drone.png";
import symbol17 from "../assets/logos/symbol/factory.png";
import symbol18 from "../assets/logos/symbol/flask.png";
import symbol19 from "../assets/logos/symbol/gear.png";
import symbol20 from "../assets/logos/symbol/globe.png";
import symbol21 from "../assets/logos/symbol/graph.png";
import symbol22 from "../assets/logos/symbol/grid.png";
import symbol23 from "../assets/logos/symbol/hash.png";
import symbol24 from "../assets/logos/symbol/headCircuit.png";
import symbol25 from "../assets/logos/symbol/hexagon.png";
import symbol26 from "../assets/logos/symbol/infinity.png";
import symbol27 from "../assets/logos/symbol/lightbulb.png";
import symbol28 from "../assets/logos/symbol/microscope.png";
import symbol29 from "../assets/logos/symbol/money.png";
import symbol30 from "../assets/logos/symbol/network.png";
import symbol31 from "../assets/logos/symbol/nut.png";
import symbol32 from "../assets/logos/symbol/package.png";
import symbol33 from "../assets/logos/symbol/parachute.png";
import symbol34 from "../assets/logos/symbol/puzzle.png";
import symbol35 from "../assets/logos/symbol/rocket.png";
import symbol36 from "../assets/logos/symbol/shark.png";
import symbol37 from "../assets/logos/symbol/shield.png";
import symbol38 from "../assets/logos/symbol/signal.png";
import symbol39 from "../assets/logos/symbol/solar.png";
import symbol40 from "../assets/logos/symbol/sparkle.png";
import symbol41 from "../assets/logos/symbol/speedometer.png";
import symbol42 from "../assets/logos/symbol/square.png";
import symbol43 from "../assets/logos/symbol/stack.png";
import symbol44 from "../assets/logos/symbol/star.png";
import symbol45 from "../assets/logos/symbol/starFour.png";
import symbol46 from "../assets/logos/symbol/target.png";
import symbol47 from "../assets/logos/symbol/toolbox.png";
import symbol48 from "../assets/logos/symbol/trend.png";
import symbol49 from "../assets/logos/symbol/triangle.png";
import symbol50 from "../assets/logos/symbol/vault.png";
import symbol51 from "../assets/logos/symbol/wallet.png";

const logoAssets = {
  accents: {
  0: null,
  1: accent1,
  2: accent2,
  3: accent3,
  4: accent4,
  5: accent5,
  6: accent6,
  7: accent7,
  8: accent8,
  9: accent9,
  10: accent10,
  11: accent11,
  12: accent12,
  13: accent13,
  14: accent14,
  15: accent15,
  16: accent16,
  17: accent17,
  18: accent18,
  19: accent19,
  20: accent20,
  21: accent21,
  22: accent22,
  23: accent23,
  24: accent24,
  25: accent25,
  26: accent26,
  27: accent27,
  28: accent28,
  29: accent29,
  30: accent30,
  31: accent31,
  32: accent32,
  33: accent33,
  34: accent34,
  35: accent35,
  36: accent36,
  37: accent37,
  38: accent38,
  39: accent39,
  40: accent40,
  41: accent41,
  42: accent42,
  43: accent43,
  44: accent44,
  45: accent45,
  46: accent46,
  47: accent47,
  48: accent48,
  49: accent49,
  50: accent50
},
  baseShapes: {
  0: null,
  1: shape1,
  2: shape2,
  3: shape3,
  4: shape4,
  5: shape5,
  6: shape6,
  7: shape7,
  8: shape8,
  9: shape9,
  10: shape10,
  11: shape11,
  12: shape12,
  13: shape13
},
  symbols: {
  0: null,
  1: symbol1,
  2: symbol2,
  3: symbol3,
  4: symbol4,
  5: symbol5,
  6: symbol6,
  7: symbol7,
  8: symbol8,
  9: symbol9,
  10: symbol10,
  11: symbol11,
  12: symbol12,
  13: symbol13,
  14: symbol14,
  15: symbol15,
  16: symbol16,
  17: symbol17,
  18: symbol18,
  19: symbol19,
  20: symbol20,
  21: symbol21,
  22: symbol22,
  23: symbol23,
  24: symbol24,
  25: symbol25,
  26: symbol26,
  27: symbol27,
  28: symbol28,
  29: symbol29,
  30: symbol30,
  31: symbol31,
  32: symbol32,
  33: symbol33,
  34: symbol34,
  35: symbol35,
  36: symbol36,
  37: symbol37,
  38: symbol38,
  39: symbol39,
  40: symbol40,
  41: symbol41,
  42: symbol42,
  43: symbol43,
  44: symbol44,
  45: symbol45,
  46: symbol46,
  47: symbol47,
  48: symbol48,
  49: symbol49,
  50: symbol50,
  51: symbol51
}
};
export default logoAssets;
